import React from "react"
import { Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { formatProductsUnits } from "@ui-seeker/utils"
import { dsColorNew } from "@palette"


export default function NumSearchesBlock({ numSearches }) {
	const isDanger = numSearches >= 1000


	return <Typography variant="subtitle2" sx={{ color: isDanger ? dsColorNew.dangerRed : dsColorNew.successText, display: 'flex', alignItems: 'center', gap: .5 }}>
		{!!isDanger && <IconSeeker icon="fire" sx={{ color: dsColorNew.dangerRed, fontSize: 11 }}/>}
		{formatProductsUnits(numSearches)}
	</Typography>
}